"use client";

import { useState, useEffect, useRef } from "react";

const STEPS = [
  { n: "1", label: "Audit",      sub: "Lighthouse\n+ GTmetrix"    },
  { n: "2", label: "Priorità",   sub: "impatto\nvs effort"        },
  { n: "3", label: "Intervento", sub: "cache · img\nCSS / JS"     },
  { n: "4", label: "Misura",     sub: "before/after\nCrUX data"   },
];

export function AuditCarousel() {
  const [active, setActive]       = useState(0);
  const [firing, setFiring]       = useState(-1); // which arrow (0-2) is animating
  const firingId                  = useRef(0);    // unique id per fire for key-reset trick
  const [fireKey, setFireKey]     = useState([0, 0, 0]);
  const [paused, setPaused]       = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => {
      setActive(prev => {
        const arrow = prev % 4; // arrow index between prev and next
        if (arrow < 3) {
          firingId.current++;
          setFiring(arrow);
          setFireKey(k => k.map((v, i) => i === arrow ? v + 1 : v));
          setTimeout(() => setFiring(-1), 420);
        }
        return (prev + 1) % 4;
      });
    }, 2200);
    return () => clearInterval(t);
  }, [paused]);

  return (
    <>
      <style>{`
        @keyframes arrowFire {
          0%   { transform: translateX(-4px) scale(0.8); opacity: 0.3; }
          45%  { transform: translateX(5px)  scale(1.3); opacity: 1;   }
          100% { transform: translateX(0)    scale(1);   opacity: 0.8; }
        }
        .arrow-fire { animation: arrowFire 0.4s cubic-bezier(.34,1.56,.64,1) forwards; }
      `}</style>

      <div
        className="not-prose my-8 rounded-xl border border-[hsl(var(--border))] p-5 bg-[hsl(210,30%,5%)]"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <p className="text-[10px] font-mono tracking-[0.18em] uppercase text-[hsl(205,18%,40%)] mb-4">
          processo d'ottimizzazione
        </p>

        <div className="flex items-stretch gap-2">
          {STEPS.map((step, i) => {
            const isActive = active === i;
            return (
              <div key={i} className="flex items-center gap-2 flex-1 min-w-0">
                {/* Card */}
                <button
                  onClick={() => { setActive(i); setPaused(true); }}
                  className={`flex-1 min-w-0 rounded-xl p-3 border text-left transition-all duration-400 cursor-pointer
                    ${isActive
                      ? "bg-[hsl(179,80%,36%,0.12)] border-[hsl(179,80%,36%,0.45)] shadow-[0_0_20px_hsl(179,80%,36%,0.15)]"
                      : "bg-[hsl(210,30%,7%)] border-[hsl(200,30%,94%,0.05)] hover:border-[hsl(179,80%,36%,0.25)] hover:bg-[hsl(210,30%,8%)]"
                    }`}
                >
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mb-2.5 transition-all duration-300
                      ${isActive ? "bg-[hsl(179,80%,36%)]" : "bg-[hsl(179,80%,36%,0.15)]"}`}
                    style={{ color: isActive ? "hsl(216,45%,3%)" : "hsl(179,80%,52%)" }}
                  >
                    {step.n}
                  </div>
                  <p className={`font-semibold text-xs transition-colors duration-300 ${isActive ? "text-[hsl(179,80%,52%)]" : "text-[hsl(205,18%,55%)]"}`}>
                    {step.label}
                  </p>
                  <p className={`text-[9px] font-mono mt-1 whitespace-pre-line leading-relaxed transition-colors duration-300 ${isActive ? "text-[hsl(179,80%,38%)]" : "text-[hsl(205,18%,32%)]"}`}>
                    {step.sub}
                  </p>
                </button>

                {/* Arrow between cards */}
                {i < 3 && (
                  <span
                    key={`arrow-${i}-${fireKey[i]}`}
                    className={firing === i ? "arrow-fire" : ""}
                    style={{
                      display: "inline-block",
                      fontSize: "18px",
                      flexShrink: 0,
                      color: active > i
                        ? "hsl(179,80%,36%)"
                        : "hsl(205,18%,22%)",
                      transition: firing === i ? undefined : "color 0.35s ease",
                    }}
                  >
                    →
                  </span>
                )}
              </div>
            );
          })}
        </div>

        {/* Progress dots */}
        <div className="flex justify-center gap-1.5 mt-4">
          {STEPS.map((_, i) => (
            <button
              key={i}
              onClick={() => { setActive(i); setPaused(true); }}
              className="transition-all duration-300 rounded-full cursor-pointer"
              style={{
                width: active === i ? "16px" : "6px",
                height: "6px",
                background: active === i ? "hsl(179,80%,36%)" : "hsl(205,18%,22%)",
              }}
              aria-label={`Step ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </>
  );
}
